import { POPULATION_TYPE, SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";
import { ModalType } from "./model";

export const get_table_config = (type: ModalType) => {
  switch (type) {
    case POPULATION_TYPE.FILE:
      return file_table_config;
    case "BUCKET":
      return bucket_table_config;
    case "CONTAINER":
      return container_table_config;
    case "STORAGE":
      return storage_table_config;
    case "SERVER":
      return server_table_config;
    case "DATA_BASE":
      return databases_table_config;
    case POPULATION_TYPE.FOLDER:
    default:
      return folder_table_config;
  }
};

const file_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "File Name",
      key: "objectName",
      spanMin: "25rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Information type",
      key: "label",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "PIIs",
      key: "piis",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },

    {
      name: "Details",
      key: "path",
      spanMin: "14rem",
      spanMax: "14rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].details",
    },
  ],
};

const folder_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Folder Name",
      key: "name",
      spanMin: "23rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "File #",
      key: "file_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },

    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },

    {
      name: "Details",
      key: "details",
      spanMin: "14rem",
      spanMax: "20rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].details",
    },
  ],
};

const bucket_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Bucket",
      key: "name",
      spanMin: "23rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Total objects #",
      key: "total_objects_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Labeled* objects #",
      key: "labeled_objects_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Samples",
      key: "samples",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },

    {
      name: "Details",
      key: "details",
      spanMin: "14rem",
      spanMax: "20rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].details",
    },
  ],
};

const container_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Container",
      key: "name",
      spanMin: "23rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Total objects #",
      key: "total_objects_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Labeled* objects #",
      key: "labeled_objects_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Samples",
      key: "samples",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },

    {
      name: "Details",
      key: "details",
      spanMin: "14rem",
      spanMax: "20rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].details",
    },
  ],
};

const storage_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Storage Account",
      key: "name",
      spanMin: "23rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Containers #",
      key: "containers_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },
    {
      name: "Details",
      key: "details",
      spanMin: "14rem",
      spanMax: "20rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].details",
    },
  ],
};

const server_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Server",
      key: "name",
      spanMin: "23rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Databases #",
      key: "databases_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },
    {
      name: "Details",
      key: "details",
      spanMin: "14rem",
      spanMax: "20rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].details",
    },
  ],
};

const databases_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Database",
      key: "name",
      spanMin: "23rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "tables/collections #",
      key: "tables_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },
    {
      name: "Details",
      key: "details",
      spanMin: "14rem",
      spanMax: "20rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].details",
    },
  ],
};
